var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMochi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#E5F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_30036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.022 11.3809C21.6507 10.939 21.1882 10.5861 20.6674 10.3474C20.1466 10.1087 19.5805 9.99017 19.0095 10.0002C18.1567 10.0091 17.3204 10.2409 16.5807 10.6733C16.2881 10.8476 15.9546 10.9382 15.6156 10.9355C15.2766 10.9328 14.9446 10.8369 14.6546 10.6579C13.996 10.222 13.2259 9.99324 12.4405 10.0002C9.91752 10.0002 7.50754 12.2054 7.07073 14.9149C6.8448 16.307 7.17617 17.657 7.97824 18.6196C8.34969 19.0613 8.81229 19.414 9.33302 19.6527C9.85374 19.8913 10.4198 20.01 10.9907 20.0002C11.8435 19.9913 12.6798 19.7596 13.4195 19.3272C13.7122 19.1529 14.0456 19.0623 14.3846 19.065C14.7236 19.0677 15.0557 19.1636 15.3456 19.3425C16.0042 19.7785 16.7743 20.0072 17.5598 20.0002C20.0827 20.0002 22.4927 17.795 22.9314 15.0856C23.1554 13.6934 22.8241 12.3435 22.022 11.3809Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_30036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    fill: "white",
    transform: "translate(7 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMochi);
export default __webpack_public_path__ + "static/media/icon_mochi.bbf9d940156bee107034a0975ab9cf8e.svg";
export { ForwardRef as ReactComponent };